import { Icon } from '@/kit/Icon';
import { TabGroup } from '@/kit/Tabs';
import { FirmNoteTexts } from './FirmNoteTexts';
import { Tooltip } from '@/kit/Tooltip';
import {
  AccountantAuditorTab,
  PolicyTab,
  ReportPointsTab,
  incorporatedLayout,
  useReportNotesSettings,
} from './ReportNotesSettingsBase';

const LAYOUT = incorporatedLayout(
  {
    reportPoints: 8,
    accountantReport: 4,
    auditorReport: 6,
    profitAndLossPolicies: 18,
    balanceSheetPolicies: 15,
  },
  ['bsPolicy2', 'bsPolicy3', 'bsPolicy4', 'bsPolicy5'],
);

/** Angular LlpComponent: `/home/settings/llp`. */
export function Llp() {
  const notes = useReportNotesSettings('llp', LAYOUT);

  return (
    <div className="form wp-100">
      <div className="sidenav-details emoji-sec pt-5">
        <div className="highlight-details">
          <Tooltip title="Accountants can update 'Accounting Policies' or related notes for all the LLPs as default from this section.">
            <Icon name="emoji_objects" className="text-yellow-200 highlight-icon" />
          </Tooltip>
        </div>
        <div className="sidenav-body">
          <TabGroup
            alignTabs="start"
            tabs={[
              {
                label: "Member's Report",
                infoText: 'Default wording points for the Members’ Report, applied to every LLP client unless overridden.',
                children: (
                  <ReportPointsTab notes={notes} heading="Member's Report Points" bodyClassName="sidenav-body pt-10" />
                ),
              },
              {
                label: "Accountant / Auditor's Report",
                infoText: "Default wording for the accountant's or auditor's report, for every LLP client.",
                children: <AccountantAuditorTab notes={notes} rowClassName="d-flex gap-30 pt-10" />,
              },
              {
                label: 'Accounting Policy',
                infoText: 'Default accounting policy wording used in the notes to the accounts for every LLP client.',
                children: <PolicyTab notes={notes} rowClassName="d-flex gap-30 pt-10" />,
              },
              {
                label: 'Default Note Text',
                infoText: 'Firm-wide default text for the other standard notes to the accounts.',
                children: <FirmNoteTexts settingsKey="llp" />,
              },
            ]}
          />
        </div>
      </div>
    </div>
  );
}
